import { useState, useEffect } from 'react'
import './Testimonials.css'

interface Testimonial {
  id: number
  name: string
  role: string
  image: string
  content: string
  event: string
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Sarah & David',
    role: 'Wedding Couple',
    image: '/images/testimonials/wedding.jpg',
    content: 'Soundmaster made our wedding day absolutely perfect! The music selection and sound quality were exceptional, and their team was incredibly professional.',
    event: 'Wedding Sound Services'
  },
  {
    id: 2,
    name: 'John Smith',
    role: 'Event Organizer',
    image: '/images/testimonials/party.jpg',
    content: 'We\'ve used Soundmaster for multiple corporate events, and they never disappoint. Their equipment is top-notch, and their service is reliable.',
    event: 'Party Sound Services'
  },
  {
    id: 3,
    name: 'Maria Nkosi',
    role: 'Birthday Celebrant',
    image: '/images/testimonials/karaoke.jpg',
    content: 'The karaoke setup was amazing! Everyone had so much fun, and the sound quality was perfect. Will definitely book again!',
    event: 'Karaoke Sound Services'
  },
  {
    id: 4,
    name: 'Tech Events SA',
    role: 'Conference Organizer',
    image: '/images/testimonials/streaming.jpg',
    content: 'Their live streaming service helped us reach a global audience. The audio quality was crystal clear, and the setup was hassle-free.',
    event: 'Live Streaming Services'
  }
]

export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  useEffect(() => {
    if (!isAutoPlaying) return

    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % testimonials.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [isAutoPlaying])

  const handleDotClick = (index: number) => {
    setActiveIndex(index)
    setIsAutoPlaying(false)
  }

  const handlePrevClick = () => {
    setActiveIndex((current) => 
      current === 0 ? testimonials.length - 1 : current - 1
    )
    setIsAutoPlaying(false)
  }

  const handleNextClick = () => {
    setActiveIndex((current) => 
      (current + 1) % testimonials.length
    )
    setIsAutoPlaying(false)
  }

  return (
    <section className="testimonials">
      <h2>What Our Clients Say</h2>
      <div className="testimonials-container">
        <button 
          className="nav-button prev" 
          onClick={handlePrevClick}
          aria-label="Previous testimonial"
        >
          ‹
        </button>

        <div className="testimonial-card">
          <div className="testimonial-image">
            <img 
              src={testimonials[activeIndex].image} 
              alt={testimonials[activeIndex].name} 
            />
          </div>
          <div className="testimonial-content">
            <p className="quote">{testimonials[activeIndex].content}</p>
            <div className="testimonial-info">
              <p className="name">{testimonials[activeIndex].name}</p>
              <p className="role">{testimonials[activeIndex].role}</p>
              <p className="event">{testimonials[activeIndex].event}</p>
            </div>
          </div>
        </div>

        <button 
          className="nav-button next" 
          onClick={handleNextClick}
          aria-label="Next testimonial"
        >
          ›
        </button>
      </div>

      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
} 